import { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';

import DownloadCard from "../../../../common/DownloadCard";
import { fetchLoginQrCode } from '../../../service';

const REFRESH_INTERVAL = 10 * 60; // 10 minutes in seconds

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        fontFamily: 'sans-serif',
        marginTop: '20px',
        padding: '10px',
    },
    cardsRow: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '20px',
        marginBottom: '30px',
    },
    qrCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        border: '1px solid #e0e0e0',
        borderRadius: '10px',
        backgroundColor: '#fafafa',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
        minWidth: '220px',
    },
    qrTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    qrImage: {
        width: '200px',
        height: '200px',
        marginBottom: '10px',
        objectFit: 'contain',
    },
    countdownText: {
        fontSize: '14px',
        color: '#555',
        marginTop: '8px',
    },
};

const QRDownload = ({ androidQr, iosQr }) => {
    const { key } = useParams();

    const [loading, setLoading] = useState(false);
    const [loginQrData, setLoginQrData] = useState(null);
    const [countdown, setCountdown] = useState(REFRESH_INTERVAL);

    const getLoginQrData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await fetchLoginQrCode(key);
            if (response.status === "Success") {
                setLoginQrData({
                    login_qr: response.login_qr,
                    temporary_token: response.temporary_token
                });
            }
        } catch (error) {
            console.error("Error fetching login QR data:", error);
        } finally {
            setLoading(false);
        }
    }, [key]);

    useEffect(() => {
        getLoginQrData();
    }, [getLoginQrData]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    getLoginQrData();
                    return REFRESH_INTERVAL;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [getLoginQrData]);

    const formatTime = (secs) => {
        const mins = Math.floor(secs / 60).toString().padStart(2, '0');
        const seconds = (secs % 60).toString().padStart(2, '0');
        return `${mins}:${seconds}`;
    };

    return (
        <>
            <DownloadCard platform="ANDROID" qrSrc={androidQr} badgeHeight="53px" />
            <DownloadCard platform="IOS" qrSrc={iosQr} badgeHeight="53px" />
            <div style={styles.wrapper}>
                {loading ? (
                    <div style={styles.qrCard}>
                        <Skeleton width={140} height={30} style={{ marginBottom: '10px' }} />
                        <Skeleton
                            variant="rounded"
                            width={styles.qrImage.width}
                            height={styles.qrImage.height}
                        />
                        <Skeleton width={100} height={20} style={{ marginTop: '10px' }} />
                    </div>
                ) : (
                    <div style={styles.qrCard}>
                        <div style={styles.qrTitle}>CONTINUE WITH MOBILE APP</div>
                        <img
                            src={loginQrData?.login_qr}
                            alt="QR Code"
                            style={styles.qrImage}
                        />
                        <div style={styles.countdownText}>
                            Refreshing in: {formatTime(countdown)}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default QRDownload;